import { Modal, Text, Box, Button } from '@nimbus-ds/components';
import { useTranslationCatalog } from 'domains/Catalog/hooks';

const { Header, Body, Footer } = Modal;

interface DeleteMetaplanModalProps {
  show: boolean;
  onClose: () => void;
  onDelete: () => void;
  isLoading: boolean;
}

export function DeleteMetaplanModal({
  show,
  onClose,
  onDelete,
  isLoading,
}: Readonly<DeleteMetaplanModalProps>): JSX.Element {
  const t = useTranslationCatalog();

  const handleDelete = (): void => {
    onDelete();
  };

  return (
    <Modal open={show} onDismiss={onClose}>
      <Header title={t('subscriptions.deleteModal.title')} />
      <Body padding="none">
        <Box display="flex" flexDirection="column" gap="4">
          <Box display="flex" flexDirection="column" gap="1">
            <Text fontWeight="bold" fontSize="base" textAlign="left">
              {t('subscriptions.deleteModal.withActiveSubscriptions')}
            </Text>
            <Text fontSize="base" textAlign="left">
              {t(
                'subscriptions.deleteModal.withActiveSubscriptionsDescription',
              )}
            </Text>
          </Box>
          <Box display="flex" flexDirection="column" gap="1">
            <Text fontWeight="bold" fontSize="base" textAlign="left">
              {t('subscriptions.deleteModal.withoutActiveSubscriptions')}
            </Text>
            <Text fontSize="base" textAlign="left">
              {t(
                'subscriptions.deleteModal.withoutActiveSubscriptionsDescription',
              )}
            </Text>
          </Box>
        </Box>
      </Body>
      <Footer>
        <Box
          display="flex"
          flexDirection="row"
          gap="2"
          justifyContent="flex-end"
        >
          <Button onClick={onClose} disabled={isLoading}>
            {t('subscriptions.deleteModal.cancel')}
          </Button>
          <Button
            onClick={handleDelete}
            appearance="danger"
            disabled={isLoading}
          >
            {t('subscriptions.deleteModal.confirm')}
          </Button>
        </Box>
      </Footer>
    </Modal>
  );
}
